import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function getStatusColor(status) {
  const colors = {
    // Job status
    scheduled: 'bg-blue-100 text-blue-800 border-blue-200',
    in_progress: 'bg-amber-100 text-amber-800 border-amber-200',
    completed: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    cancelled: 'bg-slate-100 text-slate-800 border-slate-200',
    
    // Unit status
    in_yard: 'bg-slate-100 text-slate-800 border-slate-200',
    on_rent: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    maintenance: 'bg-amber-100 text-amber-800 border-amber-200',
    
    // Route status
    planned: 'bg-blue-100 text-blue-800 border-blue-200',
    
    // Quote status
    new: 'bg-blue-100 text-blue-800 border-blue-200',
    reviewed: 'bg-amber-100 text-amber-800 border-amber-200',
    converted_to_job: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    declined: 'bg-red-100 text-red-800 border-red-200',
    
    // Service log status
    serviced: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    not_accessible: 'bg-amber-100 text-amber-800 border-amber-200',
    issue: 'bg-red-100 text-red-800 border-red-200',
    moved: 'bg-purple-100 text-purple-800 border-purple-200',
  };
  
  return colors[status] || 'bg-slate-100 text-slate-800 border-slate-200';
}

export function getJobTypeColor(type) {
  const colors = {
    delivery: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    pickup: 'bg-amber-100 text-amber-800 border-amber-200',
    service: 'bg-blue-100 text-blue-800 border-blue-200',
  };
  
  return colors[type] || 'bg-slate-100 text-slate-800 border-slate-200';
}

export function getTodayString() {
  return new Date().toISOString().split('T')[0];
}
